import { type RefObject } from 'react';

interface ProfileAvatarBlockProps {
  profile: {
    avatar: string | null;
    firstName: string | null;
    lastName: string | null;
    name: string;
  } | undefined;
  avatarInputRef: RefObject<HTMLInputElement | null>;
  initials: string;
}

export function ProfileAvatarBlock({ profile, avatarInputRef, initials }: ProfileAvatarBlockProps) {
  return (
    <div className="flex flex-col items-center gap-8 sm:flex-row sm:items-start">
      <div className="relative shrink-0">
        <div className="group relative h-32 w-32 overflow-hidden rounded-full border-4 border-secondary-100 bg-secondary-200 shadow-inner">
          {profile?.avatar ? (
            <img src={profile.avatar} alt="" className="h-full w-full object-cover" />
          ) : (
            <span className="flex h-full w-full items-center justify-center bg-secondary-200 text-3xl font-semibold text-dash-primary">
              {initials}
            </span>
          )}
          <label
            htmlFor="avatar-upload"
            className="absolute inset-0 flex cursor-pointer items-center justify-center bg-dash-primary/20 opacity-0 transition-opacity group-hover:opacity-100"
          >
            <span className="material-symbols-outlined text-3xl text-white" aria-hidden="true">
              photo_camera
            </span>
          </label>
        </div>
        <label
          htmlFor="avatar-upload"
          className="absolute bottom-0 right-0 flex cursor-pointer rounded-full bg-dash-primary p-2 text-white shadow-lg transition-transform hover:scale-110"
        >
          <span className="material-symbols-outlined text-sm" aria-hidden="true">
            edit
          </span>
        </label>
        <input
          ref={avatarInputRef}
          id="avatar-upload"
          type="file"
          accept="image/*"
          className="sr-only"
          onChange={() => {
            /* Subida de avatar pendiente de endpoint API */
          }}
        />
      </div>
      <div className="text-center sm:text-left">
        <h2 className="mb-1 text-xl font-semibold text-dash-on-surface">Foto de perfil</h2>
        <p className="mb-4 text-sm text-dash-on-surface-variant">
          JPG, GIF o PNG. Tamaño máximo según la configuración del servidor.
        </p>
        <div className="flex flex-wrap justify-center gap-3 sm:justify-start">
          <label
            htmlFor="avatar-upload"
            className="cursor-pointer rounded-lg border border-dash-primary px-4 py-2 text-sm font-bold text-dash-primary transition-colors hover:bg-dash-primary/5"
          >
            Subir nueva
          </label>
        </div>
      </div>
    </div>
  );
}
